import { Component } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { ResultProvider } from '../../../providers/result/result';
import { EventComplex, EventTievts, EventProvider } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { ResultTotalPage } from '../results-total/result-total';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-result-category',
    templateUrl: 'result-category.html',
})
export class ResultCategoryPage {
    currentPage = Array(15).fill(0);
    EVENTS_PER_PAGE = 5;
    eventType = "";
    type = "Events";

    eventsComplex = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public loadingCtrl: LoaderProvider,
        public app: App,
        public translate: TranslateService) {
        var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventType = this.navParams.data.eventType;
        this.type = this.navParams.data.type || this.type;
        console.log(this.type);
        this.eventService.getResultsCategoryComplex(this.resultService.getResultTypeAPIName(this.eventType, this.type)).then((datas: EventComplex[]) => {
            this.eventsComplex = Object.assign([], datas);
            loader.dismiss();
        });
    }

    onMorePress(i: number) {
        console.log('onMorePress: ');
        (this.app.getRootNav() as NavController).push(ResultTotalPage, { eventType: this.eventType, events: this.eventsComplex[i] });
    }

    isFirstPage(i: number): boolean {
        return (this.currentPage[i] == 0) ? true : false;
    }

    isLastPage(n: number, i: number): boolean {
        return ((this.currentPage[i] + 1) > (n / this.EVENTS_PER_PAGE)) ? true : false;
    }

    nextPage(i: number) {
        this.currentPage[i]++;
    }

    prevPage(i: number) {
        this.currentPage[i]--;
    }

    arrayOf(events: EventTievts[], i: number): EventTievts[] {
        if (events.length == 0)
            return null;

        if (this.isLastPage(events.length, i)) {
            return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] * this.EVENTS_PER_PAGE) + (events.length % this.EVENTS_PER_PAGE));
        }
        return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] + 1) * this.EVENTS_PER_PAGE);
    }
}



// WEBPACK FOOTER //
// /src/pages/results/result-category/result-category.ts